import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ContentModal } from 'components/organisms/modals/content-modal'

interface EventCancelConfirmationModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	eventId?: string
	clubId?: string
	onConfirm?: () => void
}

export function EventCancelConfirmationModal({
	open,
	setOpen,
	eventId,
	clubId,
	onConfirm,
}: EventCancelConfirmationModalProps) {
	const navigate = useNavigate()

	const handleCancel = () => {
		setOpen(false)
	}

	const handleConfirm = () => {
		onConfirm?.()
		eventId
			? navigate(clubId ? `/manage/rep-clubs/${clubId}/events/${eventId}` : `/manage/rep-clubs/events/${eventId}`)
			: navigate(clubId ? `/manage/rep-clubs/${clubId}/events` : `/manage/rep-clubs/events`)
	}

	return (
		<ContentModal title={`${!eventId ? 'Cancel' : 'Update'} Event`} open={open} setOpen={setOpen} isModal>
			<div>
				<div className="!p-6 rounded-lg border border-accent-surface bg-accent-surface/10">
					Are you sure you want to leave? You will lose all progress.
				</div>
				<div className="grid sm:grid-cols-2 grid-cols-1 items-center gap-4 mt-8">
					<button
						type="button"
						className="px-4 rounded-3xl text-center transition-all duration-300 bg-white/10 text-white font-bold block h-10 shadow-button backdrop-blur-lg hover:bg-white-25 disabled:bg-white/10 disabled:text-white-25 disabled:shadow-none whitespace-nowrap"
						onClick={handleCancel}
					>
						No, I'm not finished
					</button>
					<button
						type="button"
						className="px-4 rounded-3xl text-center transition-all duration-300 bg-primary text-white font-bold block h-10 shadow-button backdrop-blur-lg hover:bg-primary-hover disabled:bg-white/10 disabled:text-white-25 disabled:shadow-none whitespace-nowrap"
						onClick={handleConfirm}
					>
						Yes, I'm sure
					</button>
				</div>
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface EventCancelConfirmationModalManagedProps {
	eventId?: string
	clubId?: string
	onConfirm?: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'event-cancel-confirmation': EventCancelConfirmationModalManagedProps
	}
}

export function ManagedEventCancelConfirmationModal({
	onClose,
	onConfirm,
	...rest
}: EventCancelConfirmationModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<EventCancelConfirmationModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onConfirm={() => { onConfirm?.(); handleClose() }}
			{...rest}
		/>
	)
}
